export default {
  privat: {
    breadcrumbHome: 'Accueil',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Maison et terrain',
    hero: {
      eyebrow: 'Clients particuliers',
      title: 'Votre maison à l’œil : bien planifiée et installée avec discrétion',
      lead: 'Maison individuelle, appartement ou immeuble : nous protégeons votre vie privée et vos biens avec des systèmes de caméras sur mesure. Sans alarmisme, sans surveillance excessive.',
    },
    useCases: {
      title: 'Des solutions pour votre maison',
      lead: 'Chaque maison est différente. Nous étudions vos accès, conditions de lumière et souhaits, et planifions les points de surveillance adaptés.',
      items: {
        '0': { title: 'Porte et entrée', desc: 'La porte d’entrée est le point le plus important. Nous planifions une caméra discrète avec une bonne résolution, pour reconnaissance faciale et colis.' },
        '1': { title: 'Allée et garage', desc: 'Reconnaissance de plaques, surveillance des véhicules et contrôle d’accès avec caméras extérieures résistantes et vision nocturne.' },
        '2': { title: 'Jardin et terrasse', desc: 'Surveillez les accès au jardin, les terrasses et les entrées secondaires. Caméras résistantes avec grand-angle pour la vue d’ensemble.' },
        '3': { title: 'Entrées secondaires et cave', desc: 'Souvent oubliées, mais un point d’accès courant. Des caméras supplémentaires comblent la dernière brèche.' },
        '4': { title: 'Immeubles d’habitation', desc: 'Entrée, cage d’escalier et extérieurs : planifiés dans le respect de la vie privée, avec masquage et signalétique.' },
        '5': { title: 'Accès smartphone', desc: 'Vue en direct et lecture sur votre téléphone, chez vous ou en déplacement. Nous configurons tout.' },
      },
    },
    night: {
      eyebrow: 'Vision nocturne',
      title: 'Une sécurité qui ne dort jamais',
      lead: 'La plupart des incidents se produisent dans l’obscurité. Avec des caméras spéciales jour/nuit, vous gardez la vue d’ensemble même la nuit, en noir et blanc infrarouge ou en couleur.',
      items: {
        '0': { title: 'Vision nocturne infrarouge', desc: 'Images nettes même dans l’obscurité totale, jusqu’à 30 m de portée selon le modèle.' },
        '1': { title: 'Couleur nocturne', desc: 'Images en couleur la nuit au lieu du noir et blanc, grâce à des capteurs Starlight très sensibles.' },
        '2': { title: 'Éclairage intelligent', desc: 'LED à lumière blanche au mouvement, comme dissuasion et pour des enregistrements en couleur.' },
      },
    },
    privacy: {
      eyebrow: 'Protection des données',
      title: 'Protéger les zones privées, respecter les droits',
      lead: 'Pour la vidéosurveillance privée, la protection des données est particulièrement importante. Dès le départ, nous veillons à :',
      list: {
        '0': 'Ne pas capter les voies publiques ni les terrains voisins',
        '1': 'Masquage des zones privées dans la caméra ou l’enregistreur',
        '2': 'Signalétique aux entrées (recommandé légalement)',
        '3': 'Stockage local : vos données restent chez vous',
        '4': 'Droits d’accès et gestion des utilisateurs pour les immeubles',
      },
      note: 'Remarque : la licéité de la vidéosurveillance dépend du cas concret. Nous vous conseillons, sans remplacer le conseil juridique.',
    },
    cta: {
      title: 'Protégez ce qui compte pour vous',
      lead: 'Un premier entretien sans engagement vous montre les possibilités pour votre maison, en toute transparence et sans pression.',
      primary: 'Prendre rendez-vous',
      secondary: 'Lancer le planificateur de caméras',
    },
  },
};